document.addEventListener("DOMContentLoaded", function () {
  const menu = document.querySelector(".brands-mega-menu");
  const wrapper = document.getElementById("brands-directory");

  if (!menu || !wrapper) return;

  const search = document.getElementById("brand-search");
  const clear = document.getElementById("brand-search-clear");
  const noResults = document.getElementById("brand-no-results");

  const brandLinks = [...document.querySelectorAll(".brand-link")];
  const sections = [...document.querySelectorAll(".brand-letter-section")];
  const alphaLinks = [...document.querySelectorAll(".brand-alpha-link")];

  function setActiveLetter(letter) {
    alphaLinks.forEach((link) => {
      link.classList.toggle("is-active", link.dataset.letter === letter);
    });
  }

  function updateDisabledLetters() {
    alphaLinks.forEach((link) => {
      const section = document.getElementById("letter-" + link.dataset.letter);
      const disabled =
        !section ||
        section.classList.contains("is-hidden") ||
        section.querySelectorAll(".brand-link:not(.is-hidden)").length === 0;

      link.classList.toggle("is-disabled", disabled);
    });
  }

  function filterBrands() {
    const keyword = search.value.trim().toLowerCase();
    let visibleCount = 0;

    brandLinks.forEach((brand) => {
      const visible = brand.dataset.brand.includes(keyword);
      brand.classList.toggle("is-hidden", !visible);
      if (visible) visibleCount++;
    });

    sections.forEach((section) => {
      const visibleBrands = section.querySelectorAll(".brand-link:not(.is-hidden)");
      section.classList.toggle("is-hidden", visibleBrands.length === 0);
    });

    if (noResults) noResults.classList.toggle("is-hidden", visibleCount > 0);
    if (clear) clear.classList.toggle("is-visible", keyword.length > 0);

    updateDisabledLetters();
    updateActiveFromScroll();
  }

  function scrollToSection(letter) {
    const target = document.getElementById("letter-" + letter);
    if (!target) return;

    const top =
      target.getBoundingClientRect().top -
      wrapper.getBoundingClientRect().top +
      wrapper.scrollTop -
      8;

    wrapper.scrollTo({
      top: Math.max(0, top),
      behavior: "smooth",
    });

    setActiveLetter(letter);
  }

  function updateActiveFromScroll() {
    let current = "";

    sections.forEach((section) => {
      if (section.classList.contains("is-hidden")) return;

      const sectionTop =
        section.getBoundingClientRect().top -
        wrapper.getBoundingClientRect().top;

      if (sectionTop <= 40) {
        current = section.dataset.letter;
      }
    });

    if (!current) {
      const firstVisible = sections.find(
        (section) => !section.classList.contains("is-hidden")
      );
      if (firstVisible) current = firstVisible.dataset.letter;
    }

    if (current) setActiveLetter(current);
  }

  alphaLinks.forEach((link) => {
    link.addEventListener("click", function (event) {
      event.preventDefault();

      if (this.classList.contains("is-disabled")) return;

      scrollToSection(this.dataset.letter);
    });
  });

  if (search) {
    search.addEventListener("input", filterBrands);

    search.addEventListener("keydown", function (event) {
      if (event.key === "Escape") {
        search.value = "";
        filterBrands();
      }
    });
  }

  if (clear) {
    clear.addEventListener("click", function () {
      search.value = "";
      filterBrands();
      search.focus();
    });
  }

  wrapper.addEventListener("scroll", updateActiveFromScroll, { passive: true });

  menu.addEventListener(
    "wheel",
    function (event) {
      const delta = event.deltaY;
      const atTop = wrapper.scrollTop <= 0;
      const atBottom =
        wrapper.scrollTop + wrapper.clientHeight >= wrapper.scrollHeight - 1;

      const isOverWrapper = event.target.closest("#brands-directory");

      if (isOverWrapper) {
        if ((delta < 0 && atTop) || (delta > 0 && atBottom)) {
          event.preventDefault();
        }
        return;
      }

      event.preventDefault();
      wrapper.scrollTop += delta;
    },
    { passive: false }
  );

  updateDisabledLetters();
  updateActiveFromScroll();
});
document.addEventListener("DOMContentLoaded", function () {
  const mobileSearch = document.querySelector(".mobile-brands-search-input");
  if (!mobileSearch) return;

  const mobileBrands = [...document.querySelectorAll(".mobile-brand-link")];
  const mobileGroups = [...document.querySelectorAll(".mobile-brand-group")];

  mobileSearch.addEventListener("input", function () {
    const value = this.value.trim().toLowerCase();

    mobileBrands.forEach((brand) => {
      const match = brand.dataset.mobileBrand.includes(value);
      brand.classList.toggle("is-hidden", !match);
    });

    mobileGroups.forEach((group) => {
      const visible = group.querySelectorAll(".mobile-brand-link:not(.is-hidden)");
      group.classList.toggle("is-hidden", visible.length === 0);
    });
  });
});
document.addEventListener("DOMContentLoaded", function () {
  const desktopSearch = document.getElementById("brand-search");
  const desktopClear = document.getElementById("brand-search-clear");
  const desktopBrands = [...document.querySelectorAll(".brand-link")];

  if (desktopSearch) {
    desktopSearch.addEventListener("keydown", function (event) {
      if (event.key === "Escape") {
        desktopSearch.value = "";
        desktopSearch.dispatchEvent(new Event("input"));
      }

      if (event.key === "Enter") {
        const firstVisible = desktopBrands.find(
          (brand) => !brand.classList.contains("is-hidden")
        );

        if (firstVisible) {
          window.location.href = firstVisible.href;
        }
      }
    });
  }

  const mobileSearch = document.querySelector(".mobile-brands-search-input");
  const mobileBrands = [...document.querySelectorAll(".mobile-brand-link")];

  if (mobileSearch) {
    mobileSearch.addEventListener("keydown", function (event) {
      if (event.key === "Escape") {
        mobileSearch.value = "";
        mobileSearch.dispatchEvent(new Event("input"));
      }

      if (event.key === "Enter") {
        const firstVisible = mobileBrands.find(
          (brand) => !brand.classList.contains("is-hidden")
        );

        if (firstVisible) {
          window.location.href = firstVisible.href;
        }
      }
    });
  }
});
document.addEventListener("DOMContentLoaded", function () {
  const wrapper = document.getElementById("brands-directory");

  if (!wrapper) return;

  const sections = [...document.querySelectorAll(".brand-letter-section")];
  const alphaLinks = [...document.querySelectorAll(".brand-alpha-link")];

  function setActiveLetter(letter) {
    alphaLinks.forEach((link) => {
      link.classList.toggle("is-active", link.dataset.letter === letter);
    });
  }

  function updateActiveOnScroll() {
    let currentLetter = "";

    sections.forEach((section) => {
      if (section.classList.contains("is-hidden")) return;

      const sectionTop =
        section.getBoundingClientRect().top -
        wrapper.getBoundingClientRect().top;

      if (sectionTop <= 60) {
        currentLetter = section.dataset.letter;
      }
    });

    if (currentLetter) {
      setActiveLetter(currentLetter);
    }
  }

  wrapper.addEventListener("scroll", updateActiveOnScroll, {
    passive: true,
  });

  updateActiveOnScroll();
});
